export default __webpack_public_path__ + "static/media/clinica_samall.04175d7d.png";